export * from './pdfReports.service';
import { PdfReportsService } from './pdfReports.service';

export * from './company.service';
import { CompanyService } from './company.service';
export * from './customforms.service';
import { CustomformsService } from './customforms.service';
export * from './customlists.service';
import { CustomlistsService } from './customlists.service';
export * from './framelinks.service';
import { FramelinksService } from './framelinks.service';
export * from './images.service';
import { ImagesService } from './images.service';
export * from './reports.service';
import { ReportsService } from './reports.service';
export * from './system.service';
import { SystemService } from './system.service';
export * from './user.service';
import { UserService } from './user.service';
export const APIS = [CompanyService, CustomformsService, CustomlistsService, FramelinksService, ImagesService, ReportsService, SystemService, UserService,PdfReportsService];
